import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const RestoPage = () => (
  <Layout>
  <div className="masthead-followup row m-0 bg-white border border-white text-center">
	  <div className="col-12 col-md-12 p-12 p-3 p-md-5 bg-white border border-white text-dark text-center">
    <Seo title="SOFTWARE RESTORAN,PROGRAM RESTORAN,APLIKASI RESTORAN ONLINE" />
    <h2><strong>RESTO CAFE KULINER</strong></h2>
    <p>
Software program kasir resto dekstop maupun aplikasi kasir resto online usaha kuliner makanan dan minuman hingga warkop angkringan toko oleh oleh. Pilih aplikasi resto cafe mu dibawah ini
	</p></div><hr/>
<div className="col-12 col-md-8 shadow">
<img src="https://res.cloudinary.com/hockeycorp/image/upload/v1580004827/Software%20APlikasi%20Program%20kasir/software_restoran_2_i8dzbo.png" alt="software restoran program kasir restoran lengkap" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 bg-white border border-white text-left text-dark shadow rounded">	 
	 <h3 className="display-4"><Link to="/unipos" title="unipos resto">UNIPOS RESTO CAFE</Link></h3>
	 <p className="lead">terlengkap untuk usaha restoran cafe</p>
	  <Link to="/unipos" className="button btn-block" title="info software restoran lengkap">More info</Link>
	  	  </div>
	  <div class="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-center"></div>
		  <div className="col-12 col-md-8 shadow">
<img src="https://res.cloudinary.com/hockeycorp/image/upload/v1579970820/Software%20APlikasi%20Program%20kasir/mesinkasirrrestorancafeonline_jxstff.png" alt="online restoran cafe" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-12 p-3 p-md-5 bg-light border border-white text-left text-dark shadow rounded">	 
	  <h3 className="display-4"><Link to="/appresto" title="apk resto">BOOSTERPOS RESTO</Link></h3>
	  <p className="lead">Aplikasi restoran cafe modern online or offline ready</p>
	  	  <Link to="/appresto" className="button btn-block" title="app resto">More info</Link>
	  </div>
	   <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-center"></div>
 <div className="col-12 col-md-8 shadow">
<img src="https://res.cloudinary.com/hockeycorp/image/upload/v1579970919/Software%20APlikasi%20Program%20kasir/software-restoran-cafeprogram-restoran-5_iuyyd7.jpg" alt="online website restoran cafe" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 bg-white border border-white text-left text-dark shadow rounded">	 
	  <h3 className="display-4"><Link to="/onlineresto" title="online resto">ONLINE RESTO</Link></h3>	  
	 <p className="lead">Online restoran cafe apliaksi kasir resto + online order system</p>
<Link to="/onlineresto" className="button btn-block" title="online resto">More info</Link>
	  </div>
	  	   <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-center"></div>
 <div className="col-12 col-md-8 shadow">
<img src="https://res.cloudinary.com/hockeycorp/image/upload/v1579970992/Software%20APlikasi%20Program%20kasir/12_pnpqii.png" alt="mesin kasir restoran murah" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 bg-light border border-white text-left text-dark shadow rounded">	 
	  <h3 className="display-4"><Link to="/restosamba">SAMBA RESTO</Link></h3>
	  <p className="lead">Special kasir restoran full touchscreen mode electronic cash register</p>
<Link to="/restosamba" className="button btn-block">More info</Link>
	</div>
	  	  	   <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-center"></div>
 <div className="col-12 col-md-8 shadow">
<img src="https://res.cloudinary.com/hockeycorp/image/upload/v1579970962/Software%20APlikasi%20Program%20kasir/8._order_pos_penjualan_14_oozeii.png" alt="aplikasi kasir restoran android iphone" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 bg-white border border-white text-left text-dark shadow rounded">	
	  <h3 className="display-4"><Link to="mr-resto" title="aplikasi restoran penjualan modern">MR.RESTO POS</Link></h3>
	  <p className="lead">Modern dengan system order menu digital semakin keren , fokus khusus untuk penjualan kasir</p>
<Link to="/mr-resto" className="button btn-block" title="mr.resto aplikasi restoran keren">More info</Link>
	  </div>
	  	  	   <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-center"></div>
 <div className="col-12 col-md-8 shadow">
<img src="https://res.cloudinary.com/hockeycorp/image/upload/v1579970979/Software%20APlikasi%20Program%20kasir/waiters_order_ujwxl8.png" alt="aplikasi kasir restoran cafe" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 bg-light border border-white text-left text-dark shadow rounded">	
<h3 className="display-4"><Link to="noted" title="pencatatan pembukuan restoran">NOTED RESTO</Link></h3>		  
	  <p class="lead">Special pencatatan order via online web based android iphone support</p>
	     <Link to="/noted" className="button btn-block" title="Noted Resto">More info</Link>	 
	  </div>
<div class="col-12 p-3 p-md-3">
 <Link to="/kasir" className="button button-outline float-left" title="Aplikasi kasir">&larr; Kasir</Link> <Link to="/website" className="button button-outline float-right" title="pembuatan website">Website &rarr;</Link> 
	</div>
 
	</div>
  </Layout>
)

export default RestoPage